import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();
  const year = new Date().getFullYear();

  return (
    <footer style={s.footer}>

      {/* ── Top brand bar ── */}
      <div style={s.brandBar}>
        <div style={s.logoRow}>
          <div style={s.logoMark}>
            <img src="/og-image.png" alt="Nexsap" style={s.logoImg} />
          </div>
          <div>
            <p style={s.logoName}>Nexsap</p>
            <p style={s.tagline}>Discover. Like. Share.</p>
          </div>
        </div>
        <p style={s.missionText}>
          A marketplace built by the community, for the community.
          Find amazing products, support creators, and share what you love.
        </p>
      </div>

      {/* ── Links grid ── */}
      <div style={s.linksGrid}>

        <div style={s.col}>
          <p style={s.colTitle}>Get to Know Us</p>
          <button style={s.link} onClick={() => navigate('/settings')}>About Nexsap</button>
          <button style={s.link}>Careers</button>
          <button style={s.link}>Press</button>
          <button style={s.link}>Nexsap Science</button>
          <button style={s.link}>Blog</button>
        </div>

        <div style={s.col}>
          <p style={s.colTitle}>Make Money With Us</p>
          <button style={s.link} onClick={() => navigate('/creer')}>Sell on Nexsap</button>
          <button style={s.link} onClick={() => navigate('/creer')}>Become a Creator</button>
          <button style={s.link}>Advertise Your Products</button>
          <button style={s.link}>Affiliate Program</button>
          <button style={s.link}>Publish Your Brand</button>
        </div>

        <div style={s.col}>
          <p style={s.colTitle}>Discover</p>
          <button style={s.link} onClick={() => navigate('/explore')}>Explore Products</button>
          <button style={s.link} onClick={() => navigate('/videos')}>Videos</button>
          <button style={s.link} onClick={() => navigate('/category/vetements')}>Clothing</button>
          <button style={s.link} onClick={() => navigate('/category/electronique')}>Electronics</button>
          <button style={s.link} onClick={() => navigate('/category/jeux-video')}>Gaming</button>
        </div>

        <div style={s.col}>
          <p style={s.colTitle}>Need Help?</p>
          <button style={s.link}>Help Center</button>
          <button style={s.link}>Track Your Order</button>
          <button style={s.link}>Returns & Refunds</button>
          <button style={s.link}>Report a Problem</button>
          <button style={s.link} onClick={() => navigate('/messages')}>Contact Us</button>
        </div>

      </div>

      {/* ── Divider ── */}
      <div style={s.divider} />

      {/* ── Bottom bar ── */}
      <div style={s.bottomBar}>
        <div style={s.bottomLeft}>
          <div style={s.logoSmall}>
            <img src="/og-image.png" alt="Nexsap" style={{ width: '100%', height: '100%', borderRadius: 6, objectFit: 'cover' }} />
          </div>
          <p style={s.copyright}>© {year} Nexsap, Inc. All rights reserved.</p>
        </div>
        <div style={s.legalLinks}>
          <button style={s.legalBtn}>Privacy Policy</button>
          <span style={s.dot}>·</span>
          <button style={s.legalBtn}>Terms of Use</button>
          <span style={s.dot}>·</span>
          <button style={s.legalBtn}>Cookies</button>
          <span style={s.dot}>·</span>
          <button style={s.legalBtn}>Accessibility</button>
        </div>
      </div>

      {/* ── Made with love ── */}
      <p style={s.madeWith}>Made with ♥ by the Nexsap team · Connecting people through products</p>

    </footer>
  );
}

const s = {
  footer: {
    background: '#1a2440',
    color: '#c8d0e0',
    marginTop: 16,
  },

  brandBar: {
    padding: '32px 28px 24px',
    borderBottom: '1px solid rgba(255,255,255,0.08)',
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  logoRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
  logoMark: {
    width: 44,
    height: 44,
    borderRadius: 12,
    background: 'linear-gradient(135deg, #1877F2, #0a5fd1)',
    padding: 3,
    flexShrink: 0,
    overflow: 'hidden',
  },
  logoImg: {
    width: '100%',
    height: '100%',
    borderRadius: 9,
    objectFit: 'cover',
  },
  logoName: {
    fontSize: 20,
    fontWeight: 800,
    color: '#ffffff',
    letterSpacing: '-0.4px',
  },
  tagline: {
    fontSize: 12,
    color: '#6b8ab8',
    fontWeight: 500,
    marginTop: 1,
    letterSpacing: '0.5px',
  },
  missionText: {
    fontSize: 13,
    color: '#7a8fa8',
    lineHeight: 1.6,
    maxWidth: 480,
  },

  linksGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '28px 20px',
    padding: '28px 28px 24px',
  },

  col: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  colTitle: {
    fontSize: 12,
    fontWeight: 700,
    color: '#ffffff',
    letterSpacing: '0.6px',
    textTransform: 'uppercase',
    marginBottom: 4,
  },
  link: {
    background: 'none',
    border: 'none',
    color: '#7a8fa8',
    fontSize: 13,
    cursor: 'pointer',
    textAlign: 'left',
    padding: 0,
    lineHeight: 1.5,
    transition: 'color 0.15s',
    fontFamily: 'inherit',
  },

  divider: {
    height: 1,
    background: 'rgba(255,255,255,0.07)',
    margin: '0 28px',
  },

  bottomBar: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    padding: '20px 28px 12px',
  },
  bottomLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
  },
  logoSmall: {
    width: 24,
    height: 24,
    borderRadius: 6,
    overflow: 'hidden',
    background: '#1877F2',
    flexShrink: 0,
  },
  copyright: {
    fontSize: 12,
    color: '#4a6080',
  },
  legalLinks: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 4,
    alignItems: 'center',
  },
  legalBtn: {
    background: 'none',
    border: 'none',
    color: '#4a6080',
    fontSize: 11.5,
    cursor: 'pointer',
    padding: 0,
    fontFamily: 'inherit',
  },
  dot: {
    color: '#2d3f58',
    fontSize: 12,
  },

  madeWith: {
    textAlign: 'center',
    fontSize: 11.5,
    color: '#2d3f58',
    padding: '10px 28px 20px',
    borderTop: '1px solid rgba(255,255,255,0.04)',
  },
};
